<template>
    <div class="container-2" ref="cardContainer" id="portfolioCard">
        <div class="main">
            <div v-if="portfolio.isWithdrawalInProgress">
                <img src="/img/lock-blue.svg" alt="" style="margin-right: 8px;">
                <span style="font-size: 12px; color: #A4A4A4;">
                    Withdrawal Request in progress!
                </span>
            </div>
            <div v-else-if="withdrawableAmount">
                <div class="square green"></div>
                <span style="font-size: 12px; color: #39AF01;">
                    Eligible for withdrawal
                </span>
            </div>
            <div class="actionTitle" v-else-if="screen == 'upcoming' && !getTransactions[0].isEligible">
                <img src="/img/lock-blue.svg" alt="" style="margin-right: 8px;">
                <span style="font-size: 12px; color: #A4A4A4;">
                    Lock-in expiry by {{ getTransactions[0].creditedAt | nextYear | formatDate }}
                </span>
            </div>
            <div v-else-if="screen === 'upcoming' && getTransactions[0].pendingAmount" class="flexCenterAlign">
                <div class="square yellow"></div>
                <span style="font-size: 12px; color: #007AFF;">
                    Repayment Pending
                </span>
                <v-tooltip class = "tooltipContainer" max-width = "300px" top color="#ffffff">
                    <template v-slot:activator="{on, attrs}">
                        <img v-bind="attrs" v-on="on" class = "cautionImage" src = "/img/caution_icon.svg" >
                    </template>
                    <div>
                        <span class = "spanText">
                            Repayment delayed. Withdrawal on hold until payment is received.
                        </span>
                    </div>
                </v-tooltip>
            </div>
            <div class="heading">
                <div class="portfolioName">
                    {{ portfolio.planType | capitalize }} {{ portfolio.riskProfile | capitalize }}
                </div>
                <div class="amount">
                    &#x20B9;{{ portfolio.amount | localeAmountPaisaToRupee }}
                </div>
            </div>
            <div class="subHeading" :class="{ subHeading: (portfolio.isActiveWithdrawal || !portfolio.closeDate) }">
                <div class="createdDate">
                    {{ portfolio.createdAt | customFormatDate }}
                </div>
                <div class="cancelButton" v-if="screen !== 'upcoming' && portfolio.status === 'pending'">
                    <v-btn
                        icon
                        color="pink"
                        title="Cancel withdrawal request"
                        @click="showCancelDialog"
                    >
                        <v-icon
                            class="material-icons-round transactionIconsWithdraw">
                            cancel
                        </v-icon>
                    </v-btn>
                </div>
            </div>
        </div>
        <div class="dashedLine"></div>
        <div class="actions forhove" v-if="screen == 'upcoming'" @click="withdrawPortfolio">
            <span style="font-size: 13px; font-weight: 550; color: #002FA7;">
                View Transaction Details
            </span>
            <div class="right-chevron"></div>
        </div>
        <div class="actions forhove" v-else-if="portfolio.status === 'cancelled'" @click="showActiveWithdrawalDetails">
            <div class="actionTitle">
                <span style="font-size: 14px; color: red">
                    <v-icon
                        class="material-icons-round transactionIconsWithdraw">
                        cancel
                    </v-icon>
                    Cancelled
                </span>
            </div>
            <div class="right-chevron"></div>
        </div>
        <div class="actions forhove" v-else-if="portfolio.isActiveWithdrawal || !portfolio.closeDate" @click="showActiveWithdrawalDetails">
            <div class="actionTitle">
                <span style="font-size: 12px; color: #007AFF;">
                    Expected by {{ portfolio.expectedDate | formatDate }}
                </span>
            </div>
            <div class="right-chevron"></div>
        </div>
        <div class="actions forhove" v-else @click="showActiveWithdrawalDetails">
            <div class="actionTitle">
                <span style="font-size: 12px;">
                    Received on {{ portfolio.closeDate | formatDate }}
                </span>
            </div>
            <div class="right-chevron"></div>
        </div>
    </div>
</template>

<script>
import LenderService from '@/services/lenderService'
// import BaseButton from '@/components/common/uiComponents/baseButton.vue'

export default {
    name: 'PortfolioWithdrawalCard',
    components: {
        // BaseButton
    },
    props: {
        portfolio: {
            type: Object
        },
        index: {
            type: Number
        },
        screen: {
            type: String
        }
    },
    data () {
        return {
            panel: 0,
            isWithdrawDisabled: true,
            transactions: [],
            portfolioData: null,
            withdrawableAmount: 0,
            isCheckLoading: false
        }
    },
    filters: {
        nextYear (value) {
            const date = new Date(value)
            const year = date.getFullYear() + 1
            const month = date.getMonth()
            const day = date.getDate()
            return new Date(year, month, day)
        }
    },
    computed: {
        getTransactions () {
            if (!this.portfolio?.transactions || !this.portfolio?.transactions.length) {
                console.log('ehere')
            } else {
                const transactions = this.portfolio.transactions.filter(i => (i.pendingAmount || i.isProcessed !== 'full' || (i.ineligibleAmount && i.ineligibleAmount > 0)))
                if (!transactions.length) {
                    this.callFunction()
                }
                return transactions
            }
            return []
        }
    },
    async mounted () {
        if (this.screen === 'upcoming') {
            this.isCheckLoading = true
            this.$store.commit('isLoading', { message: 'We are calculating your withdrawal amount!' })
            const queryString = 'portfolioId=' + this.portfolio.portfolioId
            const response = await LenderService.getWithdrawalSummary(queryString)
            this.portfolioData = response.data.portfolio
            this.withdrawableAmount = response.data.withdrawableAmount
            this.isCheckLoading = false
            this.$store.commit('isNotLoading')

            let showLength = 0
            this.portfolio.transactions.forEach((transaction) => {
                if (!transaction.isEligible || !this.withdrawableAmount) {
                } else if (transaction.isEligible && (transaction.isProcessed !== 'full' || this.withdrawableAmount)) {
                    this.isWithdrawDisabled = false
                } else if (transaction.ineligibleAmount) {
                    this.isWithdrawDisabled = true
                } else {
                    console.log('false', showLength)
                    showLength++
                }
            })
            if (showLength === this.portfolio.transactions.length) {
                console.log('calling')
                this.callFunction()
            }
        }
    },
    methods: {
        callFunction () {
            this.$refs.cardContainer.style.display = 'none'
            this.$emit('showEmptyState')
        },
        viewWithdrawalDetails () {
            this.$emit('viewWithdrawalDetails', this.portfolio)
        },
        withdrawPortfolio () {
            if (!this.portfolio.isWithdrawalInProgress) {
                this.$emit('withdrawPortfolio', this.portfolio)
            }
        },
        showActiveWithdrawalDetails () {
            this.$emit('showActiveWithdrawalDetails')
        },
        showCancelDialog () {
            this.$emit('showCancelDialog', this.portfolio)
        }
    }
}
</script>

<style lang="scss" scoped>
    .main {
        padding-bottom: 8px;
    }

    .portfolioName {
        font-size: 17px;
        color: #232323;
        font-weight: 500;
        line-height: 16px;
    }

    .createdDate {
        font-size: 13px;
        text-transform: capitalize;
        color: #8C8C8C;
    }

    .dashedLine {
        // margin: 0px 12px;
        border: 0.6px solid #F2F6FF;
        flex: none;
        order: 1;
        flex-grow: 0;
    }

    .square {
        display: inline-block;
        border-radius: 1px;
        width: 8px;
        height: 8px;
        margin-right: 8px;
    }

    .green {
        background: #39AF01;
    }

    .yellow {
        background: #FFCB05;
    }

    .blue {
        background: #5D5FEF;
    }

    .actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px;
        cursor: pointer;
    }

    .transactions {
        display: flex;
        justify-content: space-between;
        padding: 8px 0px;
    }

    button {
        padding: 11px 24px;
        border-radius: 6px;
        letter-spacing: 0.005em;
        font-size: 14px;
        line-height: 150%;
        font-weight: 600;
        width: 100%;
    }

    .withdrawButton {
        margin: 12px 0px;
        background: #002FA7;
        color: #FFFFFF;
        width: 70%;
    }

    .transactionIconsWithdraw {
        color: #c20000;
        font-size: 18px !important;
    }

    .v-expansion-panels {
        margin-top: -4px;
    }

    .transactionAmount {
        font-weight: 600;
    }

    .v-expansion-panel::before {
        box-shadow: unset
    }

    .v-expansion-panel-header {
        padding: unset;
        font-size: 14px;
        font-weight: 500;
        margin-top: -4px;
        padding-inline: 12px;
    }

    ::v-deep .v-expansion-panel-content__wrap {
        padding: 0px 12px;
    }

    .heading {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .subHeading {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .v-expansion-panel--active > .v-expansion-panel-header--active .v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate) .v-icon {
        transform: rotate(90deg);
    }

    .amount {
        font-size: 21px;
        font-weight: 700;
    }

    .credited {
        font-size: 13px;
    }

    .title {
        line-height: unset
    }

    .v-expansion-panel--active > .v-expansion-panel-header {
        min-height: 50px;
    }

    .container-2 {
        margin-bottom: 12px;
        border-radius: 4px;
        background: #FFFFFF;
        padding: 16px;
    }

    button:disabled {
        background-color: grey;
    }

    .v-expansion-panel-header--active {
        .right-chevron {
            transform: rotate(90deg)
        }
    }

    .right-chevron {
        background-image: url(/img/chevron-right.svg);
        width: 18px;
        height: 18px;
        background-size: contain;
    }

    .right-chevron-black {
        background-image: url(/img/chevron-right-black.svg);
        width: 18px;
        height: 18px;
        background-size: contain;
    }

    .actionTitle {
        cursor: pointer;
        display: flex;
        align-items: center;
        padding: 6px 0px;
    }

    .forhove {
        &:hover {
            background-color: #f2f6ff;
            color: #000000;
            border-radius: 0px;
            .dashboard-title {
                color: #000000 !important;
            }

            .plan-text {
                color: #000000 !important;
            }
        }
    }

    .tooltipContainer {
        padding: 16px !important;
        box-shadow: 5px 20px 24px -4px rgba(16, 24, 40, 0.1), 5px 8px 8px -4px rgba(16, 24, 40, 0.04);
        background-color: #ffffff !important;
    }

    .tooltipSubContainer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .v-tooltip__content {
        opacity: 1 !important;
        text-align: center !important;
        padding: 16px !important;
        box-shadow: 5px 20px 24px -4px rgba(16, 24, 40, 0.1), 5px 8px 8px -4px rgba(16, 24, 40, 0.04);
    }

    .earningsText {
        text-align: center;
        margin-bottom: 4px !important;
        font-weight: 600;
        font-size: 16px;
        color: #0f0f0f
    }
    .spanText {
        color: #8c8c8c;
        text-align: center !important;
        font-size: 11px !important
    }
    .cautionImage {
        margin-left : 10px;
        width: 16px !important;
        height: 16px !important;
        cursor: pointer;
    }

    .flexCenterAlign {
        display: flex;
        align-items: center;
    }
</style>
